import { lazy } from "react";

const AddDriver = lazy(() => import("pages/AddDriver"));
const AddTask = lazy(() => import("pages/AddTask"));
const AddTaskTemplate = lazy(() => import("pages/AddTaskTemplate"));
const AddVehicle = lazy(() => import("pages/AddVehicle"));
const AddCompany = lazy(() => import("pages/AddCompany"));
const AddProtocol = lazy(() => import("pages/AddProtocol"));
const ProtocolDetail = lazy(() => import("pages/ProtocolDetail"));
const CompanyProfile = lazy(() => import("pages/CompanyProfile"));

const DriverDetails = lazy(() => import("pages/DriverDetails"));
const TaskDetails = lazy(() => import("pages/TaskDetails"));
const VehicleDetails = lazy(() => import("pages/VehicleDetails"));
const Partners = lazy(() => import("pages/Partners"));

const TaskTemplateDetails = lazy(() => import("pages/TaskTemplateDetails"));

const Home = lazy(() => import("pages/Home"));
const Shifts = lazy(() => import("pages/Shifts"));
const DriverShift = lazy(() => import("pages/DriverShift"));

const Login = lazy(() => import("pages/Login"));
const Drivers = lazy(() => import("pages/Drivers"));
const Tasks = lazy(() => import("pages/Tasks"));
const Vehicles = lazy(() => import("pages/Vehicles"));
const Companies = lazy(() => import("pages/Companies"));
const Protocols = lazy(() => import("pages/Protocols"));
const Notifications = lazy(() => import("pages/Notifications"));
const NotificationHistory = lazy(() => import("pages/NotificationHistory"));

const ShiftDetails = lazy(() => import("pages/ShiftDetails"));
const UserProfile = lazy(() => import("pages/UserProfile"));

const ForgotPassword = lazy(() => import("pages/ForgotPassword"));
const UberOrders = lazy(() => import("pages/UberOrders"));
const Revenue = lazy(() => import("pages/Revenue"));
const Expenses = lazy(() => import("pages/Expenses"));

const Locations = lazy(() => import("pages/Locations"));
const UberStatus = lazy(() => import("pages/UberStatus"));
const Users = lazy(() => import("pages/User"));
const Chat = lazy(() => import("pages/Chat"));
const Statements = lazy(() => import("pages/Statements"));
const FuelFilling = lazy(() => import("pages/FuelFilling"));
const ImportFuelFilling = lazy(() => import("pages/ImportFuelFilling"));
const FuelFillingCard = lazy(() => import("pages/FuelFillingCard"));

export { default } from "./AppRoutes";

export interface IRoute {
  path: string;
  element: JSX.Element;
}
export const revenueRoute: IRoute = { path: "/revenues", element: <Revenue /> };
export const conditionalRoutes: IRoute[] = [
  { path: "/expenses", element: <Expenses /> },
  { path: "/chat", element: <Chat /> },
];
export const public_routes: IRoute[] = [
  { path: "/", element: <Login /> },
  { path: "forgot-password", element: <ForgotPassword /> },
];

export const private_routes: IRoute[] = [
  { path: "/home", element: <Home /> },
  { path: "/orders", element: <UberOrders /> },
  { path: "/partners", element: <Partners /> },

  { path: "/shift", element: <DriverShift /> },
  { path: "/shift-details/:id", element: <ShiftDetails /> },

  { path: "/protocol", element: <AddProtocol /> },
  { path: "/profile", element: <UserProfile /> },
  { path: "/notification-history", element: <NotificationHistory /> },

  { path: "/locations", element: <Locations /> },
  // { path: "/chat", element: <Chat /> },

  { path: "/drivers", element: <Drivers /> },
  { path: "/driver-details/:id", element: <DriverDetails /> },
  { path: "/add-driver", element: <AddDriver /> },
  { path: "/update-driver/:id", element: <AddDriver /> },

  { path: "/users", element: <Users /> },

  { path: "/uber-status", element: <UberStatus /> },

  { path: "/task", element: <Tasks /> },
  { path: "/add-task", element: <AddTask /> },
  { path: "/task-details/:id", element: <TaskDetails /> },
  { path: "/update-task/:id", element: <AddTask /> },

  { path: "/add-task-template", element: <AddTaskTemplate /> },
  { path: "/task-template-details/:id", element: <TaskTemplateDetails /> },
  { path: "/update-task-template/:id", element: <AddTaskTemplate /> },

  { path: "/vehicles", element: <Vehicles /> },
  { path: "/add-vehicle", element: <AddVehicle /> },
  { path: "/update-vehicle/:id", element: <AddVehicle /> },
  { path: "/vehicle-details/:id", element: <VehicleDetails /> },
  { path: "/fuel-filling", element: <FuelFilling /> },
  { path: "/import-fuel-filling", element: <ImportFuelFilling /> },
  { path: "/fuel-filling-card", element: <FuelFillingCard /> },
];
export const admin_private_routes: IRoute[] = [
  { path: "/own-company", element: <CompanyProfile /> },

  { path: "/protocols", element: <Protocols /> },
  { path: "/protocol-details/:id", element: <ProtocolDetail /> },
  { path: "/update-protocol/:id", element: <AddProtocol /> },

  { path: "/notifications", element: <Notifications /> },

  { path: "/shifts", element: <Shifts /> },
  { path: "/statements", element: <Statements /> },
];

export const globalAdmin_private_routes: IRoute[] = [
  { path: "/companies", element: <Companies /> },
  { path: "/add-company", element: <AddCompany /> },
  { path: "/companies-details/:id", element: <AddCompany /> },
];
